<template>

    <v-tooltip top>
        <template v-slot:activator="{ on }">
            <v-sheet rounded
                     v-on="on"
                     class="pt-1 pb-1 pl-3 pr-3"
                     :value="value"
                     :color="statusBoxColor"
            >
                {{ value.toUpperCase() }}
            </v-sheet>
        </template>
    </v-tooltip>

</template>

<script>

import StatBoxText from "../../../components/UI/StatBoxText";

export default {

    components: {
        StatBoxText
    },

    props: {
        value: {
            type: String,
            required: true
        },
    },

    data() {
        return {}
    },

    computed: {
        statusBoxColor() {
            if (this.value.toLowerCase() === 'online') return 'green';
            if (this.value.toLowerCase() === 'offline') return 'red darken-1';
            if (this.value.toLowerCase() === 'closed') return 'blue-grey';
        },
    },
}
</script>
